import get from 'lodash/get'
import { connect } from 'react-redux'

import { SinglePageHighlights } from 'common/widgets/blocks'


export default connect(state => ({
  data: get(state, 'schoolNewServices.data.static_content.highlights', []),
}))(SinglePageHighlights)
